<p>resendemail-confirmation works!</p>
